import React from 'react';
import { FileIcon } from 'elements/Icon';

const Audio = () => (
  <FileIcon>
    <path d="M98,2v136H2V2H98 M100,0H0v140h100V0L100,0z" />
    <path d="M32.5,44v52l40.9-26L32.5,44z" />
  </FileIcon>
);

export default Audio;



// WEBPACK FOOTER //
// ./src/core/icons/components/files/types/Video.jsx